/*
 * Copyright Innov'ATM all rights reserved.
 * This software is the property of Innov'ATM and may not be used in any manner except under a
 * license agreement signed with Innov'ATM.
 */

import { createMockReactOidc } from 'oidc-spa/mock/react';
import { createReactOidc } from 'oidc-spa/react';

export const mockedTokens = {
    accessToken: 'storybook-mock-access-token',
    idToken: 'storybook-mock-id-token',
    refreshToken: 'storybook-mock-refresh-token',
};

export const { OidcProvider, useOidc, getOidc } = import.meta.env.STORYBOOK
    ? createMockReactOidc({
          isUserInitiallyLoggedIn: true,
          homeUrl: import.meta.env.BASE_URL,
          mockedTokens: mockedTokens,
          autoLogin: true,
      })
    : createReactOidc({
          issuerUri: import.meta.env.VITE_OIDC_ISSUER || '',
          clientId: import.meta.env.VITE_OIDC_CLIENT_ID || '',
          homeUrl: import.meta.env.BASE_URL,
          autoLogoutParams: { redirectTo: 'home' },
          autoLogin: true,
      });
